var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridForm',{attrs:{"id":_vm.id,"form-id":_vm.data.formId,"styles":_vm.computedStyles,"settings":_vm.data.settings,"is-user-site":_vm.$options.IS_USER_SITE,"submit-button-data":_vm.data.submitButtonData,"theme":_vm.data.settings.theme}})}
var staticRenderFns = []

export { render, staticRenderFns }